import * as React from 'react';
import "./navAccessibility.scss";

export const NavAccessibility: React.FC = () => {
    return <a 
        className="nav-accessibility" 
        href="#main-content"
    >Skip to content (Press Enter)</a>
}